import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Portal, Modal, Card, CardContent, CardHeader, Box, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
//
import { BaseOptionChart } from '../../../../components/chart';
import { getFormRatingsCommentsAction } from '../../../../services/request';

export const FormRatingsChart = props => {
  const { data } = props;

  const CHART_DATA = [
    {
      type: 'column',
      name: 'Obozy',
      data: data.ol || []
    },
    {
      type: 'column',
      name: 'Zielone szkoły',
      data: data.zs || []
    },
    {
      type: 'column',
      name: 'Półkolonie',
      data: data.pk || []
    }
  ];

  const chartOptions = _.merge(BaseOptionChart(), {
    stroke: { width: [0, 2, 3] },
    plotOptions: { bar: { columnWidth: '40%' } },
    fill: { type: ['solid'] },
    labels: _.map(data.choices, arr => arr[1]) || [],
    yaxis: [
      {
        title: {
          text: 'Liczba ocen'
        }
      }
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: y => y
      },
      x: {
        show: true
      }
    }
  });

  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Card>
        <CardHeader title="Wykres ocen formularzy" action={<Button onClick={() => setOpen(true)}>Zobacz komentarze</Button>}/>
        <Box sx={{ p: 3, pb: 1 }} dir="ltr">
          <ReactApexChart series={CHART_DATA} options={chartOptions} height={364}/>
        </Box>
      </Card>
      {open ? <CommentsModal open={open} handleClose={() => setOpen(false)}/> : null}
    </>
  );
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


function CommentsModal({ open, handleClose }) {
  const { loading, payload, error } = useQuery(getFormRatingsCommentsAction());

  console.log(payload);


  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <Card sx={{ ...style, width: '500px' }}>
          <CardHeader title="Komentarze" action={
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }/>

          <CardContent sx={{ overflow: 'auto', maxHeight: '500px', display: 'grid', gap: '16px' }}>
            {loading ? <p>Ładowanie komentarzy...</p> : error ? <p>Nie udało się pobrać komentarzy</p> : <>
              {payload.map(item => <div key={item.id} style={{ border: '1px solid #ddd', padding: '8px 12px', borderRadius: '12px' }}>
                <span style={{ color: '#888', fontWeight: 600, fontSize: '14px' }}>{item.form_title}</span>
                <p>{item.description}</p>
              </div>)}
            </>}
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
